import "./AlertModal.css";
import {useEffect, useState} from "react";
import { v4 as uuidv4 } from "uuid";

export const BaseModalActions = {
    CLOSE : "close"
};

export const BaseModal = (props) => {

    const {shown} = props;
    const {forceDismiss} = props;

    const [key, setKey] = useState(uuidv4);
    const [isDismissing, setIsDismissing] = useState(false);

    useEffect(() => {
        let dismissTimer = undefined;
        if (isDismissing) {
            clearTimeout(dismissTimer);
            dismissTimer = setTimeout(() => {
                setIsDismissing(false);
                handleCallback(BaseModalActions.CLOSE);
            }, 200);
        }

        return () => {
            clearTimeout(dismissTimer);
        }
    }, [isDismissing]);

    useEffect(() => {
        if (forceDismiss === true && !isDismissing) {
            setIsDismissing(true);
        }
    }, [forceDismiss]);

    function handleCallback(action) {
        if (props.callback !== undefined) {
            props.callback(action);
        }
    }

    if (!shown) return [];

    let useKey = "balm-" + key;
    let classExtra = "";
    if (isDismissing) {
        useKey += "-d";
        classExtra = " dismissing";
    }

    return (
        <div className={"alert-modal" + classExtra} key={useKey}>
            <div className={"spacer"} />

            <div className={"container"}>
                <div className={"row"}>
                    <div className={"hidden-xs col-md-3 col-lg-4"} />
                    <div className={"col-12 col-md-6 col-lg-4"}>
                        <div className={"alert-modal-dialog"}>
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>

            <div className={"spacer"} />
        </div>
    )

}